<main
	[formGroup]="mainForm"
	class="py-46px px-[65px] bg-off-white rounded-12px max-w-[900px] m-auto"
>
	<div class="mb-36px">
		<app-countries-tabs
			[selectedCountry]="countryId"
			(countryId)="changeCountry($event)"
		></app-countries-tabs>
	</div>
	<section>
		<h1 class="text-dark-grey text-font-16 font-DIN-Bold">
			{{ 'POINTING_SYSTEM.CUSTOMIZING_POINTS.GENERAL_POINTS' | translate }}
		</h1>
		<div class="bg-off-white rounded-12px p-24px shadow">
			<div *ngFor="let item of generalValuesArray">
				<ng-container formGroupName="{{ removeSpaces(item?.name?.en) }}">
					<mat-slide-toggle formControlName="isActive" class="mb-16px">
						{{
							translate.currentLang == 'en' ? item?.name?.en : item?.name?.ar
						}}</mat-slide-toggle
					>
					<div class="flex gap-[12px] mb-24px">
						<mat-form-field appearance="outline" class="w-1/2">
							<mat-label class="text-dark-grey">
								{{
									'POINTING_SYSTEM.CUSTOMIZING_POINTS.NUMBER_OF_POINTS'
										| translate
								}}
							</mat-label>
							<input
								(wheel)="$event.preventDefault()"
								(keypress)="keypressValidation($event)"
								formControlName="points"
								class="text-dark-grey"
								matInput
								placeholder="	{{
									'POINTING_SYSTEM.CUSTOMIZING_POINTS.NUMBER_OF_POINTS'
										| translate
								}}"
								required
								type="number"
							/>
							<mat-error>
								<validation-message
									[controller]="
										getSubController(removeSpaces(item?.name?.en), 'points')
									"
									controller_name="POINTING_SYSTEM.CUSTOMIZING_POINTS.NUMBER_OF_POINTS"
								>
								</validation-message>
							</mat-error>
						</mat-form-field>
					</div>
				</ng-container>
			</div>
		</div>
	</section>
	<section class="mt-36px">
		<h1 class="text-dark-grey text-font-16 font-DIN-Bold">
			{{ 'POINTING_SYSTEM.CUSTOMIZING_POINTS.MARKET_PLACE_POINTS' | translate }}
		</h1>
		<div class="bg-off-white rounded-12px p-24px shadow">
			<div *ngFor="let item of marketPlaceValuesArray">
				<ng-container formGroupName="{{ removeSpaces(item?.name?.en) }}">
					<mat-slide-toggle formControlName="isActive" class="mb-16px">
						{{
							translate.currentLang == 'en' ? item?.name?.en : item?.name?.ar
						}}</mat-slide-toggle
					>
					<div class="flex gap-[12px] mb-24px items-start">
						<mat-form-field appearance="outline" class="w-1/2">
							<mat-label class="text-dark-grey">
								{{
									'POINTING_SYSTEM.CUSTOMIZING_POINTS.NUMBER_OF_POINTS'
										| translate
								}}
							</mat-label>
							<input
								(wheel)="$event.preventDefault()"
								(keypress)="
									keypressValidation(
										$event,
										item?.name?.en == 'Check out' ? 'Check out' : null
									)
								"
								formControlName="points"
								class="text-dark-grey"
								matInput
								placeholder="{{
									'POINTING_SYSTEM.CUSTOMIZING_POINTS.NUMBER_OF_POINTS'
										| translate
								}}"
								required
								type="number"
							/>
							<mat-error *ngIf="item?.name?.en !== 'Check out'">
								<validation-message
									[controller]="
										getSubController(removeSpaces(item?.name?.en), 'points')
									"
									controller_name="POINTING_SYSTEM.CUSTOMIZING_POINTS.NUMBER_OF_POINTS"
								>
								</validation-message>
							</mat-error>
							<mat-error *ngIf="item?.name?.en == 'Check out'">
								{{ 'VALIDATION.MIN_NO' | translate : { number: 0 } }}
							</mat-error>
						</mat-form-field>
						<mat-form-field appearance="outline" class="w-1/2">
							<mat-label class="text-dark-grey"
								>{{
									'POINTING_SYSTEM.CUSTOMIZING_POINTS.VALID_NUM_PER_DAY'
										| translate
								}}
							</mat-label>
							<input
								formControlName="limitPerDay"
								class="text-dark-grey"
								matInput
								placeholder="{{
									'POINTING_SYSTEM.CUSTOMIZING_POINTS.VALID_NUM_PER_DAY'
										| translate
								}}"
								type="number"
								(wheel)="$event.preventDefault()"
								(keypress)="keypressValidation($event)"
							/>
							<mat-error>
								<validation-message
									[controller]="
										getSubController(
											removeSpaces(item?.name?.en),
											'limitPerDay'
										)
									"
									controller_name="POINTING_SYSTEM.CUSTOMIZING_POINTS.VALID_NUM_PER_DAY"
								>
								</validation-message>
							</mat-error>
						</mat-form-field>
					</div>
				</ng-container>
			</div>
		</div>
	</section>
	<section class="mt-36px">
		<h1 class="text-dark-grey text-font-16 font-DIN-Bold">
			{{ 'POINTING_SYSTEM.CUSTOMIZING_POINTS.SALON_POINTS' | translate }}
		</h1>
		<div class="bg-off-white rounded-12px p-24px shadow">
			<div *ngFor="let item of salonValuesArray">
				<ng-container formGroupName="{{ removeSpaces(item?.name?.en) }}">
					<mat-slide-toggle formControlName="isActive" class="mb-16px">
						{{
							translate.currentLang == 'en' ? item?.name?.en : item?.name?.ar
						}}</mat-slide-toggle
					>
					<div class="flex gap-[12px] mb-24px items-start">
						<mat-form-field appearance="outline" class="w-1/2">
							<mat-label class="text-dark-grey">
								{{
									'POINTING_SYSTEM.CUSTOMIZING_POINTS.NUMBER_OF_POINTS'
										| translate
								}}
							</mat-label>
							<input
								(wheel)="$event.preventDefault()"
								(keypress)="
									keypressValidation(
										$event,
										item?.name?.en == 'Booking' ? 'Booking' : null
									)
								"
								formControlName="points"
								class="text-dark-grey"
								matInput
								placeholder="{{
									'POINTING_SYSTEM.CUSTOMIZING_POINTS.NUMBER_OF_POINTS'
										| translate
								}}"
								required
								type="number"
							/>
							<mat-error *ngIf="item?.name?.en !== 'Booking'">
								<validation-message
									[controller]="
										getSubController(removeSpaces(item?.name?.en), 'points')
									"
									controller_name="POINTING_SYSTEM.CUSTOMIZING_POINTS.NUMBER_OF_POINTS"
								>
								</validation-message>
							</mat-error>
							<mat-error *ngIf="item?.name?.en == 'Booking'">
								{{ 'VALIDATION.MIN_NO' | translate : { number: 0 } }}
							</mat-error>
						</mat-form-field>
						<mat-form-field appearance="outline" class="w-1/2">
							<mat-label class="text-dark-grey"
								>{{
									'POINTING_SYSTEM.CUSTOMIZING_POINTS.VALID_NUM_PER_DAY'
										| translate
								}}
							</mat-label>
							<input
								formControlName="limitPerDay"
								class="text-dark-grey"
								matInput
								placeholder="{{
									'POINTING_SYSTEM.CUSTOMIZING_POINTS.VALID_NUM_PER_DAY'
										| translate
								}}"
								type="number"
								(wheel)="$event.preventDefault()"
								(keypress)="keypressValidation($event)"
							/>
							<mat-error>
								<validation-message
									[controller]="
										getSubController(
											removeSpaces(item?.name?.en),
											'limitPerDay'
										)
									"
									controller_name="POINTING_SYSTEM.CUSTOMIZING_POINTS.VALID_NUM_PER_DAY"
								>
								</validation-message>
							</mat-error>
						</mat-form-field>
					</div>
				</ng-container>
			</div>
		</div>
	</section>
	<section class="mt-36px">
		<h1 class="text-dark-grey text-font-16 font-DIN-Bold">
			{{ 'GENERAL_LABELS.SETTINGS' | translate }}
		</h1>
		<div class="bg-off-white rounded-12px p-24px shadow">
			<div *ngFor="let item of settingValuesArray">
				<h1 class="text-dark-grey text-font-16">
					{{
						item == 'pointCost'
							? ('POINTING_SYSTEM.CUSTOMIZING_POINTS.POINTS_COST_VALUE'
							  | translate)
							: ('POINTING_SYSTEM.CUSTOMIZING_POINTS.EXPIRY_DATE' | translate)
					}}
				</h1>
				<mat-form-field appearance="outline" class="w-full">
					<input
						[formControlName]="item"
						class="text-dark-grey"
						matInput
						required
						[min]="0.00000001"
						type="number"
						placeholder="{{
							item == 'pointCost'
								? ('POINTING_SYSTEM.CUSTOMIZING_POINTS.POINTS_COST' | translate)
								: ('POINTING_SYSTEM.CUSTOMIZING_POINTS.EXPIRY_DATE' | translate)
						}}"
						(wheel)="$event.preventDefault()"
						(keypress)="
							item !== 'pointCost' ? keypressValidation($event) : null
						"
					/>
					<span
						*ngIf="item == 'pointCost'"
						class="text-dark-grey mx-2"
						matSuffix
					>
						{{
							this.countryId == 103
								? ('CURRENCY.SAR' | translate)
								: ('CURRENCY.EGP' | translate)
						}}
					</span>
					<span
						*ngIf="item !== 'pointCost'"
						class="text-dark-grey mx-2"
						matSuffix
					>
						{{ 'GENERAL.DAYS' | translate }}
					</span>
					<mat-error>
						<div
							class="whitespace-nowrap text-font-12"
							*ngIf="
								getController(removeSpaces(item))?.hasError('required') &&
								getController(removeSpaces(item))?.touched
							"
						>
							{{
								'VALIDATION.REQUIRED'
									| translate
										: {
												name:
													(item == 'pointCost'
														? 'POINTING_SYSTEM.CUSTOMIZING_POINTS.POINTS_COST'
														: 'POINTING_SYSTEM.CUSTOMIZING_POINTS.EXPIRY_DATE'
													) | translate
										  }
							}}
						</div>
						<div
							class="whitespace-nowrap"
							*ngIf="
								getController(removeSpaces(item))?.hasError('min') &&
								getController(removeSpaces(item))?.touched
							"
						>
							{{ 'VALIDATION.MIN_NO' | translate : { number: 0 } }}
						</div>
					</mat-error>
				</mat-form-field>
			</div>
		</div>
	</section>
	<div class="mt-36px">
		<button
			(click)="submit()"
			mat-button
			[disabled]="mainForm.invalid"
			class="bg-gradient text-off-white block w-full"
		>
			{{ 'ACTIONS.SAVE' | translate }}
		</button>
		<button
			class="border border-solid border-[#D9DBE9] text-dark-grey py-8px rounded-6px w-full mt-[10px]"
		>
			{{ 'ACTIONS.CANCEL' | translate }}
		</button>
	</div>
</main>
